var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBenefitSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5466 62.2802C70.259 55.6379 64.4127 50.625 57.3912 50.625C50.3698 50.625 44.5235 55.6379 43.2359 62.2802C42.9567 63.7136 44.0901 65.0429 45.5486 65.0429H69.2298C70.6924 65.0429 71.8216 63.7178 71.5425 62.2802H71.5466Z",
    fill: "url(#paint0_linear_2323_17098)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3914 47.2359C61.3451 47.2359 64.5503 44.0307 64.5503 40.0769C64.5503 36.1231 61.3451 32.918 57.3914 32.918C53.4376 32.918 50.2324 36.1231 50.2324 40.0769C50.2324 44.0307 53.4376 47.2359 57.3914 47.2359Z",
    fill: "url(#paint1_linear_2323_17098)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2323_17098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.97 61.5786C50.3532 53.2529 43.0234 46.9648 34.2226 46.9648C25.4219 46.9648 18.0921 53.2529 16.4753 61.5786C16.1252 63.3788 17.542 65.0414 19.3755 65.0414H49.0656C50.8991 65.0414 52.3159 63.3788 51.9658 61.5786H51.97Z",
    fill: "url(#paint2_linear_2323_17098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2226 47.3723C42.6918 47.3723 49.7681 53.33 51.4929 61.2808L51.5659 61.6564C51.8653 63.1962 50.652 64.634 49.0656 64.634H19.3755C17.7891 64.634 16.5758 63.1962 16.8752 61.6564L16.8752 61.6563C18.4556 53.5183 25.6207 47.3723 34.2226 47.3723Z",
    stroke: "url(#paint3_linear_2323_17098)",
    strokeWidth: 0.814815
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2323_17098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2773 42.4787C41.0996 41.3405 44.0863 36.5085 42.9481 31.6861C41.8099 26.8637 36.9779 23.8771 32.1555 25.0153C27.3331 26.1535 24.3465 30.9855 25.4847 35.8079C26.6229 40.6303 31.4549 43.6169 36.2773 42.4787Z",
    fill: "url(#paint4_linear_2323_17098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5516 31.7797C43.6381 36.3831 40.7871 40.9957 36.1837 42.0822C31.5803 43.1687 26.9677 40.3177 25.8812 35.7143C24.7947 31.1109 27.6457 26.4983 32.2491 25.4118C36.8525 24.3253 41.4651 27.1763 42.5516 31.7797Z",
    stroke: "url(#paint5_linear_2323_17098)",
    strokeWidth: 0.814815
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2323_17098",
    x: 1.75521,
    y: 32.2982,
    width: 64.931,
    height: 47.4095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2323_17098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2323_17098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2323_17098",
    x: 10.5755,
    y: 10.1068,
    width: 47.2806,
    height: 47.2806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2323_17098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2323_17098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2323_17098",
    x1: 57.3912,
    y1: 72.9769,
    x2: 57.3912,
    y2: 29.6273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2323_17098",
    x1: 57.4233,
    y1: 55.2478,
    x2: 57.3914,
    y2: 29.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2323_17098",
    x1: 18.4316,
    y1: 64.0209,
    x2: 31.3788,
    y2: 38.5245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2323_17098",
    x1: 18.9346,
    y1: 48.3865,
    x2: 30.672,
    y2: 73.1005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2323_17098",
    x1: 28.2988,
    y1: 43.321,
    x2: 40.134,
    y2: 24.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2323_17098",
    x1: 24.9807,
    y1: 28.1587,
    x2: 43.2624,
    y2: 40.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitSmall);
export default __webpack_public_path__ + "static/media/icon-benefit-small.8ef0e7f856d179b7af3ee9411fc0ba52.svg";
export { ForwardRef as ReactComponent };